import { BgColorType, SpacingType } from "@/lib/main";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  bgColor?: BgColorType;
  className?: HTMLAttributes<HTMLElement>["className"];
  id?: HTMLAttributes<HTMLElement>["id"];
  gap?: SpacingType;
  width?: CSSProperties["width"];
}>;

export default function SectionArticle({
  bgColor,
  children,
  className,
  id,
  gap,
  width,
}: Props) {
  if (!gap) {
    gap = "xl";
  }

  const styles: CSSProperties = {
    overflow: "hidden",

    backgroundColor: bgColor
      ? `var(--color-background-${bgColor})`
      : "var(--color-background-frame)",
    borderRadius: "var(--border-radius-sm)",

    display: "flex",
    flexDirection: "column",
    gap: `var(--spacing-${gap})`,
    padding: "var(--spacing-xl)",
    width: width || "100%",
  };

  return (
    <article className={className} id={id} style={styles}>
      {children}
    </article>
  );
}
